import React from "react";
import About from "../components/musicfestival/home/about";
import Banner from "../components/musicfestival/home/banner";
import OurTicket from "../components/musicfestival/home/ourTicket";
import WhatWeDo from "../components/musicfestival/home/whatwedo";
import Header from "../components/musicfestival/layouts/header";

const MusicFestival = () => {
  return (
    <div className="bg-[#1D1D1D] flex flex-col min-h-screen pb-14">
      <Header />
      <Banner />
      <About />
      <WhatWeDo/>
      <OurTicket/>
      {/* <div className="mt-auto">
        <Footer />
      </div> */}
    </div>
  );
};

export default MusicFestival;
